var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-brush"},[_c('div',{staticClass:"bg"},[_c('inline-svg',{attrs:{"color":_vm.color,"id":"bg-large"}})],1),_c('div',{staticClass:"bg-brush--content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }